import React, {useContext} from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {routes} from "./Routes";
import PrivateRoute from "./PrivateRoute";
import MainLayout from "../pages/Dashboard";

export default function Router() {
    return (
        <BrowserRouter>
            <Routes>
                {routes.map(route => (
                    route.isPrivate ? (
                        <Route key={route.path} path={"/"} element={<MainLayout/>}>
                            <Route key={route.path} path={route.path}
                                   element={<PrivateRoute element={route.component} requiredRoles={route.requiredRoles}/>}
                            />
                        </Route>
                    ) : (
                        <Route key={route.path} path={route.path} element={route.component}/>
                    )
                ))}

                <Route path={"*"} element={<Navigate to={"/login"}/>}/>
                <Route path={"/404"} element={<h1>404</h1>}/>
            </Routes>
        </BrowserRouter>
    )
}